import { z } from "zod";

export const UploadCogsDataRequestBodySchema = z.object({
  bucket: z.string(),
  key: z.string(),
});

export type UploadCogsDataRequestBodyType = z.infer<
  typeof UploadCogsDataRequestBodySchema
>;
